// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2ht6p","title":"Header_title__1GdF2","side":"Header_side__sVzXI"};